<template>

  <div class="region-link" v-if="region !== undefined">
    <div class="name">{{ region.name }}</div>
  </div>

</template>

<script>

export default {
  name: 'RegionLink',
  props: ['id'],
  computed: {
    region () {
      return this.$store.state.regions[this.id]
    }
  },
  methods: {
    toggleDetails () {
      this.$router.push(`/regions/${this.id}`)
    }
  },
  mounted () {
    if (!this.$store.state.regions[this.id]) {
      this.$store.dispatch('getRegion', this.id)
    }
  }
}

</script>

<style lang="scss" scoped>

  .name {
    display: inline;
  }

  .id {
    display: inline;
    color: gray;
    margin-left: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/links/Region.vue